import React from "react";
import SingleChoice from "../../components/singleChoice";
import { useWizard } from "react-use-wizard";
import NavigateBack from "../../components/navigateBack";

const SelectDoctor = ({ availableDoctors, onSubmitHandler }) => {
  const selectDoctorQuestionData = {
    question: "Select your preferred Doctor",
    choices: availableDoctors?.map((doctor) => ({
      text: doctor.name,
      value: doctor.code,
    })),
    qKey: "selectDoctor",
    selectedChoice: null,
  };

  const { nextStep } = useWizard();

  return (
    <div>
      <NavigateBack />
      <SingleChoice
        question={selectDoctorQuestionData.question}
        choices={selectDoctorQuestionData.choices}
        qKey={selectDoctorQuestionData.qKey}
        onSubmitHandler={(doctor) => {
          onSubmitHandler(doctor);
          nextStep();
        }}
      />
    </div>
  );
};

export default SelectDoctor;
